import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import DashboardLayout from './layouts/DashboardLayout';
import LoginPage from './pages/LoginPage';
import OverviewPage from './pages/OverviewPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetailsPage from './pages/OrderDetailsPage';
import ProductsPage from './pages/ProductsPage';
import ProductEditPage from './pages/ProductEditPage';
import ProductStats from './pages/ProductStats';
import UsersPage from './pages/UsersPage';
import UserDetailsPage from './pages/UserDetailsPage';
import CategoriesPage from './pages/CategoriesPage';
import SettingsPage from './pages/SettingsPage';
import SupportRequestsPage from './pages/SupportRequestsPage';
import SupportRequestDetailPage from './pages/SupportRequestDetailPage';
import VendorPage from './pages/VendorPage';
import VendorEditPage from './pages/VendorEditPage';
import ReferralPage from './pages/ReferralPage';
import ProtectedRoute from './components/ProtectedRoute';
import RequireRole from './components/RequireRole';
import CompaniesPage from './pages/CompaniesPage';
import EmployeesPage from './pages/EmployeesPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/overview" replace />} />
            <Route path="overview" element={<OverviewPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:id" element={<OrderDetailsPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="products/new" element={<ProductEditPage />} />
            <Route path="products/edit/:id" element={<ProductEditPage />} />
            <Route path="products/stats/:id" element={<ProductStats />} />
            <Route path="categories" element={<RequireRole allowedRoles={["admin"]}><CategoriesPage /></RequireRole>} />
            <Route path="users" element={<RequireRole allowedRoles={["admin"]}><UsersPage /></RequireRole>} />
            <Route path="users/:id" element={<UserDetailsPage />} />
            <Route path="vendors" element={<RequireRole allowedRoles={["admin"]}><VendorPage /></RequireRole>} />
            {/* Referral flow handled in main application; dashboard does not expose /vendors/refer */}
            <Route path="vendors/new" element={<RequireRole allowedRoles={["admin"]}><VendorEditPage /></RequireRole>} />
            <Route path="vendors/:id" element={<RequireRole allowedRoles={["admin"]}><div>Vendor Details Page (Coming Soon)</div></RequireRole>} />
            <Route path="vendors/:id/edit" element={<RequireRole allowedRoles={["admin"]}><VendorEditPage /></RequireRole>} />
            <Route path="referrals" element={<RequireRole allowedRoles={["admin"]}><ReferralPage /></RequireRole>} />
            <Route path="support-requests" element={<SupportRequestsPage />} />
            <Route path="support-requests/:id" element={<SupportRequestDetailPage />} />
            <Route path="settings" element={<RequireRole allowedRoles={["admin"]}><SettingsPage /></RequireRole>} />
            <Route path="companies" element={<RequireRole allowedRoles={["seller"]}><CompaniesPage /></RequireRole>} />
            <Route path="companies/:id" element={<RequireRole allowedRoles={["seller"]}><div>Company Details Page (Coming Soon)</div></RequireRole>} />
            <Route path="companies/:id/edit" element={<RequireRole allowedRoles={["seller"]}><VendorEditPage /></RequireRole>} />
            <Route path="employees" element={<RequireRole allowedRoles={["seller"]}><EmployeesPage /></RequireRole>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
